var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 78,
    viewBox: "0 0 41 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9419 0.543597C22.5271 -0.181199 16.0502 -0.181199 9.6354 0.543597L2.99276 1.29414C2.01018 1.40516 1.24186 2.18702 1.15444 3.16487L0.643854 8.87623C-0.214617 18.4789 -0.214618 28.1383 0.643853 37.741L1.15444 43.4524C1.24978 44.5188 2.14972 45.3363 3.2282 45.3363H11.8533V75.9332C11.8533 76.8112 12.4121 77.5934 13.2468 77.8837C14.0815 78.1739 15.0099 77.909 15.5619 77.223L17.1887 75.2011C26.8879 63.1462 34.6113 49.6483 40.0742 35.2048L40.8671 33.1082C41.1072 32.4735 41.0184 31.7623 40.6295 31.205C40.2406 30.6477 39.6011 30.3151 38.9181 30.3151H27.6213L37.3041 4.058C37.5236 3.4629 37.4559 2.80075 37.1204 2.26157C36.7849 1.72239 36.2188 1.36581 35.5845 1.29414L28.9419 0.543597Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.61632ddd493dba42e99caf83dae144c0.svg";
export { ForwardRef as ReactComponent };